import { CloseOutlined } from '@icon';
import classNames from 'classnames';
import RCDialog, { DialogProps as BaseProps } from 'rc-dialog';
import 'rc-dialog/assets/index.css';
import React from 'react';
import { useTheme } from 'styled-components';
import ModalActions from './components/modal-actions';
import { modalClasses, ModalDescription, ModalStyles, ModalTitle } from './modal.styled';
import { useModal } from './modal.utils';

export interface ModalProps extends Omit<BaseProps, 'animation' | 'fade' | 'closeIcon'> {
  contentTitle?: React.ReactNode;
  contentDescription?: React.ReactNode;
}

const Modal = ({
  children,
  className,
  onClose,
  closable = true,
  maskClosable = true,
  title,
  mask = true,
  width = 600,
  ...rest
}: ModalProps): JSX.Element => {
  const theme = useTheme();

  return (
    <>
      <ModalStyles />
      <RCDialog
        {...rest}
        width={width}
        closable={closable}
        className={classNames(modalClasses.component, className, {
          'close-mask': maskClosable,
        })}
        animation="zoom"
        maskAnimation="fade"
        closeIcon={null}
        maskClosable={maskClosable}
        mask={mask}
        title={
          <div className={modalClasses.header}>
            <span className={modalClasses.title}>{title ?? ''}</span>
            {closable ? (
              <button className={modalClasses.closeBtn} onClick={onClose}>
                <CloseOutlined color={theme.color.tint.action} width={24} height={24} />
              </button>
            ) : null}
          </div>
        }
      >
        {children}
      </RCDialog>
    </>
  );
};

Modal.useModal = useModal;
Modal.Title = ModalTitle;
Modal.Description = ModalDescription;
Modal.Actions = ModalActions;

export default Modal;
